import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "uxp-spectrum-widgets-to-swc-mapping"
    }}>{`UXP Spectrum widgets to SWC mapping`}</h1>
    <p>{`This document provides a comprehensive mapping guide for transitioning from Spectrum UXP widgets to their corresponding SWC (Spectrum Web Component) UXP equivalents. Use this guide to seamlessly map your required UI components and ensure a smooth transition between the two libraries.`}</p>
    <p>{`The status of each component represents the following `}<br></br>{`
✅ : Ready to be integrated.`}<br></br>{`
🟡  : The component exists in the SWC library but is not yet supported by UXP.`}<br></br>{`
N/A : The corresponding component does not exist in the SWC library.`}<br></br></p>
    <br></br>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Control Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Spectrum UXP Widget`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Corresponding SWC in UXP`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Status`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Avatar`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`sp-avatar`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`sp-avatar`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`✅`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Body`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`sp-body`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`N/A`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`N/A`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Button`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`sp-button`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`sp-button`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`✅`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`ButtonGroup`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`sp-button-group`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`sp-button-group`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`✅`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Checkbox`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`sp-checkbox`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`sp-checkbox`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`✅`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Detail`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`sp-detail`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`N/A`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`N/A`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Dialog`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`sp-dialog`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`sp-dialog`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`✅`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Divider`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`sp-divider`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`sp-divider`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`✅`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Heading`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`sp-heading`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`N/A`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`N/A`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Icon`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`sp-icon`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`sp-icon`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`✅`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Label`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`sp-label`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`sp-field-label`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`✅`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Link`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`sp-link`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`sp-link`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`✅`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Menu`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`sp-menu`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`sp-menu`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`✅`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`MenuItem`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`sp-menu-item`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`sp-menu-item`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`✅`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`MenuGroup`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`sp-menu-group`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`sp-menu-group`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`✅`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`MenuDivider`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`sp-menu-divider`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`sp-menu-divider`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`✅`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Meter`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`sp-meter`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`sp-meter`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`🟡`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Overlay`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`sp-overlay`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`sp-overlay`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`🟡`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Picker`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`sp-picker`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`sp-picker`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`🟡`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Popover`}{` `}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`sp-popover`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`sp-popover`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`✅`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Progressbar`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`sp-progressbar`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`sp-progress-bar`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`🟡`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Radio`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`sp-radio`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`sp-radio`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`✅`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`RadioGroup`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`sp-radio-group`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`sp-radio-group`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`✅`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Slider`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`sp-slider`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`sp-slider`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`🟡`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Switch`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`sp-switch`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`sp-switch`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`✅`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Textarea`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`sp-textarea`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`sp-textfield (multiline)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`🟡`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Textfiled`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`sp-textfield`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`sp-textfield/sp-number-field/sp-search`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`✅`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Tooltip`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`sp-tooltip`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`sp-tooltip`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`✅`}</td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      